import { default as _91_46_46_46slug_93shoYX7yfr1Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/[...slug].vue?macro=true";
import { default as index9INcisDM11Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/auth/index.vue?macro=true";
import { default as indexjOXRlzw18GMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93blRCzmuCcgMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93b8iTsP8Wv3Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93y0dZdcXXLSMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93SAkO4ZUDx7Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/news/[slug].vue?macro=true";
import { default as organisationsOfsX5jb833Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsTb0IgBx2aZMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsjom9LftA7oMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexEGnlat1dpYMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/processes/index.vue?macro=true";
import { default as dungeonRfWRDt1iaFMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsUOkxzhfquqMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexQcSIRW4J1MMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/secret/index.vue?macro=true";
import { default as indexw5NGvJmWKqMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataAp8qhTGfxuMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClasslTfo9r2grZMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93aFXUm7KtkHMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexwgb8JjCtNPMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseData95LftJWLG6Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsGP9dj2lKhCMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReports53XbpRI1OZMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsHnno3oybKWMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93aHL49uezmfMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexc6TfB3EKa9Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesypd8rr2eF1Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataV3a41OybvpMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93YMJtdaarLjMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexfM0MMMUUAqMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesk0MjSjPcGwMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataZP9J6geaaDMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93F56FVpXUavMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexprtREGX6LbMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataBGT4zfjDm9Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93YgGfAthPAXMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexVlHVHSWB6ZMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataePILmLTgL2Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassLSUXCHolinMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormshQqzdu4UIgMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93SsXnzIuwp9Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexTdcWR35f2OMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivities3wCydgq18UMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataGML57s5ReGMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsqhKuKSRiy7Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as statisticSurveyRightsFLirNTG7SRMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue?macro=true";
import { default as _91id_93UT4CYMUhqaMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexXMWlVHR2j1Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesb0wwxDz3RdMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataT0N5PF6mgcMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotifications0zyVrf9WxtMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_937rIPTVXMeoMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexnj7dMvu6KLMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataqXLsQRDuY5Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearData8q4MsBnKfTMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93S3lZvEg6SVMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexyi5wFmq9ciMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatalTG4KiyRQ5Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93sIXGOchiMiMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as index8GKwi6Pb62Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsVHoMkZ3QfEMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatabAsxYcAjVZMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93PjN1RhNQfgMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexI15bse4ZX9Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesfJdPuCcAqrMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesmANi2g1syOMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsbZlmkORne1Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataoTSR5TZTvhMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiaskqhI73kwC3Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishes9xz4beKrcmMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93Wj1EvY0UQwMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexHcFHvAG0eQMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsNDzRkWXKcBMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltYS8Cna9iqZMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunActivitiesViFbvYtvApMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue?macro=true";
import { default as paymentRunBaseDatao7peS28IMLMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsr4RJmkcca2Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_931i0KPfQnDQMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexwfsxbW0M77Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsO4LPSp2y97Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesDbCMeaFM4UMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseData8LPuDBPqOQMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_932QD1sMtOcPMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/[id].vue?macro=true";
import { default as indexAVa9ccva7PMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalnyqHf9TdUSMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93DASc4MzVPAMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as index2pRMFZMyRtMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProviderstcW1VfwnQWMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesXfT23mLUnRMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsgeGklYt0yYMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatam5szpaSTfJMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesOleifCP9KmMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConcept2IPI01sECuMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementLOHzhuDoTbMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersi9Mz6FpVOGMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_933xW9sDhMINMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexez5HwZYgGrMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisations6NI6ppEiIyMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesDfbRoolNEyMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataAqhQsNw016Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersVbkyWOUdXOMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureyuvKHWODuDMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_935JMG9EFPrIMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexfLyZfKG2kiMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/index.vue?macro=true";
import { default as users8q8ER57SCgMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users.vue?macro=true";
import { default as settingsNWvPAuAACpMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesEuuUQSxgcoMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDatadNErT5uT6kMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93pC231sNFoqMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexT9U04YSarVMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as _91id_93p7pTL75A7iMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcessTransfers/[id].vue?macro=true";
import { default as indexxwjUOvnoPNMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcessTransfers/index.vue?macro=true";
import { default as serviceR9ST2CNeTfMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service.vue?macro=true";
import { default as languageYZZNC4oVNXMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataV9JSHeEJEtMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesgZDrNHi58VMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementJhUIrtFyhVMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersBagojRvTLxMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93ieObqeqUeAMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatahsZidCi0trMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userReportsAL8eMwhoUzMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id]/userReports.vue?macro=true";
import { default as userSignatureFfuURqZBraMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93I7xTgl4KzFMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id].vue?macro=true";
import { default as index3ksb3r4tgJMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/index.vue?macro=true";
import { default as settingsB5HLdvxjznMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings.vue?macro=true";
import { default as signatureQ2nct6pPazMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/signature.vue?macro=true";
import { default as sportbizzOL975CjoxRMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93EIJmDui6llMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_939w0fGaU8yaMeta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexeNfFMAQMI0Meta } from "/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/statistics/index.vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93shoYX7yfr1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: index9INcisDM11Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexjOXRlzw18GMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93blRCzmuCcgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93b8iTsP8Wv3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93y0dZdcXXLSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsOfsX5jb833Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexEGnlat1dpYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceR9ST2CNeTfMeta?.name,
    path: "/service",
    meta: serviceR9ST2CNeTfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatalTG4KiyRQ5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexw5NGvJmWKqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93aFXUm7KtkHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexwgb8JjCtNPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93aHL49uezmfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexc6TfB3EKa9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93YMJtdaarLjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexfM0MMMUUAqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93F56FVpXUavMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexprtREGX6LbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93YgGfAthPAXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexVlHVHSWB6ZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93SsXnzIuwp9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexTdcWR35f2OMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93UT4CYMUhqaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyRights",
    path: "statisticSurveyRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexXMWlVHR2j1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_937rIPTVXMeoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotifications0zyVrf9WxtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexnj7dMvu6KLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93S3lZvEg6SVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexyi5wFmq9ciMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93sIXGOchiMiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesfJdPuCcAqrMeta?.name,
    path: "parishes",
    meta: parishesfJdPuCcAqrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93PjN1RhNQfgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsNDzRkWXKcBMeta?.name,
    path: "regions",
    meta: regionsNDzRkWXKcBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93Wj1EvY0UQwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsO4LPSp2y97Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_931i0KPfQnDQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunActivities",
    path: "paymentRunActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexwfsxbW0M77Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_932QD1sMtOcPMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexAVa9ccva7PMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalnyqHf9TdUSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsNWvPAuAACpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProviderstcW1VfwnQWMeta?.name,
    path: "loginProviders",
    meta: loginProviderstcW1VfwnQWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93DASc4MzVPAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: index2pRMFZMyRtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisations6NI6ppEiIyMeta?.name,
    path: "organisations",
    meta: organisations6NI6ppEiIyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_933xW9sDhMINMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexez5HwZYgGrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: users8q8ER57SCgMeta?.name,
    path: "users",
    meta: users8q8ER57SCgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_935JMG9EFPrIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexfLyZfKG2kiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93pC231sNFoqMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexT9U04YSarVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcesses/index.vue")
  },
  {
    name: "service-statisticProcessTransfers-id",
    path: "statisticProcessTransfers/:id()",
    meta: _91id_93p7pTL75A7iMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcessTransfers/[id].vue")
  },
  {
    name: "service-statisticProcessTransfers",
    path: "statisticProcessTransfers",
    meta: indexxwjUOvnoPNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/service/statisticProcessTransfers/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsB5HLdvxjznMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93ieObqeqUeAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93I7xTgl4KzFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userReports",
    path: "userReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id]/userReports.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: index3ksb3r4tgJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureQ2nct6pPazMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzOL975CjoxRMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93EIJmDui6llMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_939w0fGaU8yaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexeNfFMAQMI0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20261102114531/client/pages/statistics/index.vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]